<template>
    <div class="wrapper auth-split w-100 h-100">
        <div class="auth-split__photo" aria-hidden="true"></div>
        <div class="auth-split__panel">
        <v-card class="auth-split__card" elevation="0">
            <v-card-title>
                <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                    <div class="text-black d-flex flex-column align-center">
                        <v-img :src="logo" :width="75" draggable="false"/>
                        <v-img :src="logoText" :width="100" draggable="false"/>
                    </div>
                </router-link>
            </v-card-title>
            <v-card-title>Change Your Password</v-card-title>
            <v-card-text>
                <v-alert type="info" variant="tonal" class="mb-4">
                    Your password was reset by an administrator. Please choose a new password to continue.
                </v-alert>
                <v-form ref="form" v-model="formValid" validate-on="input lazy" @submit.prevent="changePassword">
                    <v-text-field v-model="currentPassword" :rules="[vRules.required]"
                                  autocomplete="current-password"
                                  label="Current/Temporary Password" type="password"/>
                    <v-text-field v-model="newPassword" :rules="[vRules.required, vRules.minLength(8)]"
                                  autocomplete="new-password"
                                  label="New Password" type="password"/>
                    <v-text-field v-model="confirmPassword"
                                  :rules="[vRules.required, v => v === newPassword || 'Passwords do not match']"
                                  autocomplete="new-password"
                                  label="Confirm New Password" type="password"/>
                    <v-btn :disabled="!formValid" :loading="processing" block color="primary" type="submit"
                           class="mt-2">Update Password
                    </v-btn>
                </v-form>
            </v-card-text>
        </v-card>
        </div>
    </div>
</template>

<script setup>
import {ref} from 'vue'
import router from "@/router"
import {send} from '@/composables/apiClient'
import logo from "@/assets/images/logo-1.png"
import logoText from "@/assets/images/logo-text.png"
import {useAuthStore} from '@/stores/authStore'
import {landingRoute} from '@/composables/globals'
import {useSnackbarStore} from '@/stores/snackBarStore'

const auth = useAuthStore()
const snackbar = useSnackbarStore()
const form = ref(null)
const formValid = ref(false)
const processing = ref(false)
const currentPassword = ref(null)
const newPassword = ref(null)
const confirmPassword = ref(null)

const changePassword = () => {
    processing.value = true
    send('put', 'users/password', {
        current_password: currentPassword.value,
        password: newPassword.value,
        password_confirmation: confirmPassword.value,
    }).then((response) => {
        if (response.data.success) {
            snackbar.showSnackbar('Password updated successfully!')
            router.push({name: landingRoute(useAuthStore())})
        }
    }).catch((error) => {
        const msg = error.response?.data?.message ?? 'Failed to update password'
        snackbar.showSnackbar(msg, 'error')
    }).finally(() => processing.value = false)
}
</script>

<style scoped>
.wrapper {
    height: 100%;
}
</style>
